import './TimeSelector.scss';

import React, { forwardRef } from 'react';
import Box from 'fe-design-base/atoms/Box';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

import TimeOption from './TimeOption';

const { cx } = cxHelpers('TimeSelector');

const TimeSelector = forwardRef(
  ({ value, onSelect, options, onMouseDown }, ref) => (
    <Box className={cx()} w="100%" fixed onMouseDown={onMouseDown} ref={ref}>
      {options.map(option => (
        <TimeOption
          key={option}
          selected={value === option}
          option={option}
          onSelect={onSelect}
        />
      ))}
    </Box>
  )
);

TimeSelector.propTypes = {
  className: PropTypes.string,
  optionClass: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
};

export default TimeSelector;
